import { render, staticRenderFns } from "./ModalSlides.vue?vue&type=template&id=f289f7c6&scoped=true&"
import script from "./ModalSlides.vue?vue&type=script&lang=js&"
export * from "./ModalSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f289f7c6",
  null
  
)

export default component.exports